import React from 'react';

interface RotationToggleProps {
  clockwise: boolean;
  setClockwise: (value: boolean) => void;
}

const RotationToggle: React.FC<RotationToggleProps> = ({ clockwise, setClockwise }) => {
  return (
    <div className="rotation-toggle">
      <span>Rotation: {clockwise ? 'Clockwise' : 'Counter-Clockwise'}</span>
      <label className="switch">
        <input
          type="checkbox"
          checked={clockwise}
          onChange={() => setClockwise(!clockwise)}
        />
        <span className="slider"></span>
      </label>
    </div>
  );
};

export default RotationToggle;